var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 39.4286C30.731 39.4286 39.4295 30.7301 39.4295 20C39.4295 9.26988 30.731 0.571396 20.0009 0.571396C9.27075 0.571396 0.572266 9.26988 0.572266 20C0.572266 30.7301 9.27075 39.4286 20.0009 39.4286Z",
    fill: "#E34506",
    stroke: "#E34506",
    strokeWidth: 1.51429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4324 22.9109L24.1701 22.6525C23.904 22.6213 23.6343 22.6508 23.3814 22.7387C23.1284 22.8266 22.8986 22.9707 22.7094 23.1602L21.0704 24.7991C18.5419 23.5132 16.4868 21.458 15.2008 18.9295L16.8487 17.2818C17.2316 16.8987 17.4186 16.3643 17.3563 15.8209L17.098 13.5764C17.0475 13.142 16.839 12.7412 16.5121 12.4505C16.1853 12.1598 15.763 11.9995 15.3255 12H13.7847C12.7782 12 11.9409 12.8372 12.0033 13.8437C12.4754 21.4501 18.5588 27.5246 26.1563 27.9967C27.1628 28.059 28 27.2218 28 26.2153V24.6744C28.0088 23.7748 27.3319 23.0178 26.4324 22.9109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneImg);
export default __webpack_public_path__ + "static/media/Phone-Img.7ae0a0f7bdb99bfd8b4f9dc7b4318e33.svg";
export { ForwardRef as ReactComponent };